import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
} from '@material-ui/core';
import {
  object,
  string,
} from 'yup';
import { FormattedMessage } from 'react-intl';
import { MY_FORM_FIELD_TEXT } from '../../form-constants';
import MyForm from '../../MyForm';

const nameLink = 'myInputHTML_link';

export const imageFields = [
  {
    type: MY_FORM_FIELD_TEXT,
    name: nameLink,
    labelId: 'myInputHTML.form.link.link',
    inputProps: {
      autoFocus: true,
      placeholder: 'http://example.com',
    },
  },
];

export const imageValidationSchema = object({
  [nameLink]: string('')
    .trim()
    .url('myInputHTML.form.link.link.valid')
    .required('myInputHTML.form.link.link.required'),
});
const MyInputHTMLLinkDialog = (props) => {
  const {
    open,
    onClose,
    onConfirm,
    disabled,
    addLink,
    initialValues,
  } = props;

  const formikRef = React.useRef(null);

  const handleSubmit = () => {
    formikRef.current.handleSubmit();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <FormattedMessage id={addLink ? 'myInputHTML.linkDialog.addLink' : 'myInputHTML.linkDialog.changeLink'} />
      </DialogTitle>
      <DialogContent>
        <MyForm
          onSubmit={onConfirm}
          fields={imageFields}
          validationSchema={imageValidationSchema}
          disabled={disabled}
          initialValues={initialValues}
          formikRef={formikRef}
          useSubmitButton={false}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          disabled={disabled}
        >
          <FormattedMessage id="seed.button.cancel" />
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={disabled}
        >
          <FormattedMessage id="seed.button.save" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

MyInputHTMLLinkDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,

  initialValues: PropTypes.shape({
    myInputHTML_link: PropTypes.string,
  }),
  addLink: PropTypes.bool,
  open: PropTypes.bool,
  disabled: PropTypes.bool,
};

MyInputHTMLLinkDialog.defaultProps = {
  initialValues: {
    myInputHTML_link: '',
  },
  addLink: true,
  open: false,
  disabled: false,
};

export default MyInputHTMLLinkDialog;
